export default __webpack_public_path__ + "static/media/alexAvatar.a8a65756.png";